export default __webpack_public_path__ + "manual_shade.png";